export const SHIFT_BLOCKS_PATH = "shiftBlocks";
